import React, { ChangeEvent, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ValidationError } from 'yup'
import { updateSidebarShipment } from 'apps/booking/utils/actions/sidebar'
import { isUpdatingShipment } from 'apps/booking/utils/selectors/shipment'
import { vinCheckSchema } from 'apps/booking/utils/validationSchema'
import { TextInput } from 'components/atoms'
import { InlineEditContainer } from 'transfix-ui'
import { DISPLAY } from 'constants/display'

interface IVinInlineEditProps {
  shipmentId: number
  vin?: string
}

const VinInlineEdit = ({ shipmentId, vin }: IVinInlineEditProps) => {
  const dispatch = useDispatch()
  const [isVinEditModeEnabled, setVinEditModeEnabled] = useState(false)
  const [error, setError] = useState<string | undefined>(undefined)
  const [currentVin, setCurrentVin] = useState<string | undefined>(undefined)
  const isLoading = useSelector(isUpdatingShipment)
  const changingVin = currentVin && vin !== currentVin

  const handleVinChange = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    vinCheckSchema
      .validate(value)
      .then(() => {
        setCurrentVin(value)
        setError(undefined)
      })
      .catch(({ message }: ValidationError) => {
        setError(message)
      })
  }

  useEffect(() => {
    if (!isVinEditModeEnabled && changingVin) {
      const params = { info: { vin: currentVin } }
      dispatch(updateSidebarShipment(shipmentId, params))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isVinEditModeEnabled])

  return (
    <InlineEditContainer
      name='tractorVin'
      className='dib'
      dataTest='tractor-vin-inline-edit'
      onEditModeRequested={() => setVinEditModeEnabled(!isVinEditModeEnabled)}
      editModeEnabled={isVinEditModeEnabled}
      editMode={
        <TextInput
          name='tractorVin'
          label='Tractor Vin'
          onChange={handleVinChange}
          value={vin}
          dataTest='tractor-vin-input'
          className='mv2'
          invalid={Boolean(error)}
          validationMessage={error}
        />
      }>
      <p className='text-secondary b'>Tractor VIN</p>
      {isLoading && changingVin ? <div className='spinner' /> : vin || DISPLAY.none}
    </InlineEditContainer>
  )
}

export default VinInlineEdit
